import { css } from 'react-emotion'

const styles = {
  DashboardLayout: css({
    height: '100vh'
  }),
  grid: css({
    height: '100%'
  }),
  content: css({
    height: '100vh',
    width: '100vw'
  }),
  mainContent: css({
    height: '100%',
    overflow: 'hidden',
    '@media(min-width: 991px)': {
      paddingLeft: '260px',
    }
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Layouts/DashboardStyles.js